import React, { Fragment } from 'react';
import PropTypes from 'prop-types';
import './pain-points.css';
import { useTranslation } from 'react-i18next';

const PainPoints = (props) => {
  const { t } = useTranslation();
  return (
    <div className={`pain-points-container1 thq-section-padding ${props.rootClassName} `}>
      <img alt={props.image1Alt} src={props.image1Src} className='pain-points-image thq-img-ratio-16-9' />
      <div className='pain-points-max-width thq-section-max-width'>
        <h1>
          {props.heading ?? (
            <Fragment>
              <span className='pain-points-text12'>{t('painPoints.heading')}</span>
            </Fragment>
          )}
        </h1>
        <div className='pain-points-container2'>
          <span className='pain-points-text11'>
            {props.text1 ?? (
              <Fragment>
                <span className='pain-points-text13'>{t('painPoints.text')}</span>
              </Fragment>
            )}
          </span>
        </div>
      </div>
    </div>
  );
};

PainPoints.defaultProps = {
  image1Src:
    'https://images.unsplash.com/photo-1528543606781-2f6e6857f318?ixid=M3w5MTMyMXwwfDF8c2VhcmNofDIxfHx0cmF2ZWx8ZW58MHx8fHwxNzUwMjI3NzA1fDA&ixlib=rb-4.1.0&w=1500',
  heading: undefined,
  text1: undefined,
  image1Alt: 'Schengen Visa Appointment Notifications',
  rootClassName: '',
};

PainPoints.propTypes = {
  image1Src: PropTypes.string,
  heading: PropTypes.element,
  text1: PropTypes.element,
  image1Alt: PropTypes.string,
  rootClassName: PropTypes.string,
};

export default PainPoints;
